<template>
  <section id="live" class="live-section">
    <iframe
      id="appFrame"
      allow="autoplay; geolocation; microphone; camera"
      allowfullscreen
      :src="'https://studiov2.lyceum.one/webrtc?room=' + room_number"
    ></iframe>
    <div class="control-wrapper">
      <b-button-group>
        <b-button
          v-if="!controls.play"
          size="sm"
          variant="primary"
          @click="startVideo"
        >
          <font-awesome-icon icon="play"></font-awesome-icon>
          <span>Start</span>
        </b-button>
        <b-button
          v-if="controls.play"
          size="sm"
          variant="primary"
          @click="stopVideo"
        >
          <font-awesome-icon icon="stop"></font-awesome-icon>
          <span>Stop</span>
        </b-button>
        <b-button
          v-if="!controls.mute"
          size="sm"
          variant="primary"
          @click="muteAudio"
        >
          <font-awesome-icon icon="volume-mute"></font-awesome-icon>
          <span>Mute</span>
        </b-button>
        <b-button
          v-if="controls.mute"
          size="sm"
          variant="primary"
          @click="unmuteAudio"
        >
          <font-awesome-icon icon="volume-up"></font-awesome-icon>
          <span>Unmute</span>
        </b-button>
        <b-button
          v-if="!controls.fullscreen"
          size="sm"
          variant="primary"
          @click="toggleFullScreen"
        >
          <font-awesome-icon icon="expand"></font-awesome-icon>
          <span>Full Screen</span>
        </b-button>
        <b-button
          v-if="controls.fullscreen"
          size="sm"
          variant="primary"
          @click="toggleFullScreen"
        >
          <font-awesome-icon icon="compress"></font-awesome-icon>
          <span>Exit Full Screen</span>
        </b-button>
      </b-button-group>
    </div>
  </section>
</template>

<script>
export default {
  name: "live-start",
  data() {
    return {
      frame: "",
      room_number: "",
      courseId: "",
      videoUrl: "",
      controls: {
        play: false,
        mute: false,
        fullscreen: false
      }
    };
  },
  mounted() {
    this.frame = document.querySelector("#appFrame");
    this.room_number = this.$route.query.roomNumber;
    this.courseId = this.$route.query.course_id;
    console.log(this.frame);
    setTimeout(() => {
      this.frame.contentWindow.postMessage({ type: "startlocalstream" }, "*");
    }, 1000);
    window.addEventListener("message", function(msg) {
      console.log("got message>>", msg.data);
      if (msg.data.type === "downgraded") {
        // this.frame.contentWindow.postMessage({ type: "stoplocalstream" }, "*");
      } else if (msg.data.type === "addrecord") {
        this.videoUrl =
          "https://studiov2.lyceum.one/asset/" +
          msg.data.data.filename +
          ".mp4";
      }
    });
  },
  methods: {
    startVideo() {
      let data = { record: true, title: this.courseId };
      this.frame.contentWindow.postMessage(
        { type: "upgrade", data: data },
        "*"
      );
      this.controls.play = true;
    },
    stopVideo() {
      this.frame.contentWindow.postMessage({ type: "downgrade" }, "*");
      this.controls.play = false;
      this.uploadUrl();
    },
    muteAudio() {
      this.frame.contentWindow.postMessage({ type: "muteaudio" }, "*");
      this.controls.mute = true;
    },
    unmuteAudio() {
      this.frame.contentWindow.postMessage({ type: "unmuteaudio" }, "*");
      this.controls.mute = false;
    },
    toggleFullScreen() {
      let elem = document.getElementById("live");
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
    },
    uploadUrl() {
      console.warn(">>>>>>>>>>this.videoUrl<<<<<<<<<<<<<<<", this.videoUrl);
    }
  }
};
</script>

<style scoped></style>
